<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay variant="white" :show="loading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <b-card no-body>
        <b-card-body>
          <b-row class="align-items-center">
            <b-col md="8">
              <b-button variant="outline-secondary" class="mr-1" @click="$router.push('/contenedores')">
                <feather-icon icon="ArrowLeftIcon" class="mr-50" />
                Volver
              </b-button>
              <b-button variant="primary" class="mr-1" @click="addRow">
                <feather-icon icon="PlusIcon" class="mr-50" />
                Agregar item
              </b-button>
              <b-button variant="success" :disabled="saving" @click="submitValidate">
                <b-spinner v-if="saving" small class="mr-50" />
                <feather-icon v-else icon="CheckSquareIcon" class="mr-50" />
                Validar
              </b-button>
            </b-col>
            <b-col md="4" class="text-right mt-1 mt-md-0">
              <b-badge variant="light-primary">Items: {{ details.length }}</b-badge>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <b-card no-body class="mb-0">
        <b-table
          class="position-relative"
          :hover="true"
          :items="details"
          responsive
          :fields="fields"
          show-empty
          empty-text="No existen items para validar"
        >
          <template #cell(brand)="data">
            <b-form-input v-model="data.item.brand" placeholder="Marca" />
          </template>

          <template #cell(code)="data">
            <b-form-input v-model="data.item.code" placeholder="Codigo" />
          </template>

          <template #cell(qty)="data">
            <b-form-input v-model.number="data.item.qty" type="number" min="1" placeholder="Cantidad" />
          </template>

          <template #cell(actions)="data">
            <b-button
              size="sm"
              variant="flat-danger"
              :disabled="details.length === 1"
              v-b-tooltip.hover.top="'Eliminar'"
              @click.prevent="removeRow(data.index)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </template>
        </b-table>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ContainerService from '@/services/ContainerService'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      loading: false,
      saving: false,
      fields: [
        { key: 'brand', label: 'MARCA', sortable: false },
        { key: 'code', label: 'CODIGO', sortable: false },
        { key: 'qty', label: 'CANTIDAD', sortable: false },
        { key: 'actions', label: 'ACCIONES' },
      ],
      details: [
        {
          brand: '',
          code: '',
          qty: null,
        },
      ],
    }
  },
  methods: {
    addRow() {
      this.details.push({
        brand: '',
        code: '',
        qty: null,
      })
    },
    removeRow(index) {
      if (this.details.length === 1) return
      this.details.splice(index, 1)
    },
    isValidDetail(item) {
      return item.brand && item.code && Number(item.qty) > 0
    },
    responseMessage(resp, fallback) {
      return (resp && resp.message) || (resp && resp.data && resp.data.message) || fallback
    },
    responseHasError(resp) {
      return (resp && resp.error === true) || (resp && resp.data && resp.data.error === true)
    },
    buildPayload() {
      return {
        detail: this.details.map(item => ({
          brand: String(item.brand).trim(),
          code: String(item.code).trim(),
          qty: Number(item.qty),
        })),
      }
    },
    async submitValidate() {
      const payload = this.buildPayload()
      const invalid = payload.detail.some(item => !this.isValidDetail(item))

      if (invalid) {
        this.$swal({
          title: 'Datos incompletos',
          text: 'Completa marca, codigo y cantidad mayor a 0 en todos los items.',
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
        return
      }

      this.saving = true
      this.loading = true
      const resp = await ContainerService.validateContainer(this.$route.params.id, payload, this.$store)
      this.saving = false
      this.loading = false

      if (resp && !this.responseHasError(resp)) {
        const message = this.responseMessage(resp, 'La validacion se proceso correctamente.')
        this.$swal({
          title: 'Contenedor validado',
          text: message,
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        }).then(() => {
          this.$router.push('/contenedores')
        })
      } else {
        const message = this.responseMessage(resp, 'Hubo un error al validar el contenedor.')
        this.$swal({
          title: 'Error!',
          text: message,
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      }
    },
  },
}
</script>
